module.exports = __webpack_public_path__ + "css/logo.svg?67e77cd0c42408a4ec7f2caa4bb772a3";